import { Button } from '@/components/ui/button';
import { CapTableFinality } from '@/types/captable';

interface CapTableFinalityToggleProps {
  finality: CapTableFinality;
  onFinalityChange: (finality: CapTableFinality) => void;
}

export function CapTableFinalityToggle({
  finality,
  onFinalityChange,
}: CapTableFinalityToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground">Show:</span>
      <div
        className="flex"
        title="Incl. drafts shows everything, confirmed work and drafts alike. Confirmed shows only what has been approved or posted."
      >
        <Button
          variant={finality === CapTableFinality.WORKING ? 'default' : 'ghost'}
          size="sm"
          className="h-9 px-3 text-xs rounded-r-none"
          onClick={() => onFinalityChange(CapTableFinality.WORKING)}
        >
          Incl. drafts
        </Button>
        <Button
          variant={finality === CapTableFinality.OFFICIAL ? 'default' : 'ghost'}
          size="sm"
          className="h-9 px-3 text-xs rounded-l-none border-l"
          onClick={() => onFinalityChange(CapTableFinality.OFFICIAL)}
        >
          Confirmed
        </Button>
      </div>
    </div>
  );
}
